const base = {
    baseUrl: "",
    menus: "/api/manager/menu/menuList",
    userInfo: "/user/info/my",
    loginCaptchaToken: "/login/captchaToken",
    login: "/m/accountLogin",
    logout: "/api/user/logout?channel=0",

    getOssKeySecret: "/manager/oss/getOssKeySecret",
    updateSystemConfig: '/api/manager/config/update',
    getSystemConfig: '/manager/system/setting/getSettings',
    updateImageValue: '/api/manager/config/updateImageValue',
    getEnumOptionList: '/api/manager/enum/list4select/{0}',
    startPractice: '/user/exam/startPractice?subject={0}',
    acknowledgeCircuitRoutingIntroduction: '/user/exam/acknowledgeCircuitRoutingIntroduction',
    beginReaction: '/user/exam/reaction/{0}/begin',
    submitReactionAnswers: '/user/exam/reaction/{0}/answers',
    finishReaction: '/user/exam/reaction/{0}/finish',
    queryCurrentQuestion: '/user/exam/queryCurrentQuestion?examId={0}&history=true',
    submitAnswer: '/user/exam/submitAnswer',
    queryHistoryExamResult: '/user/exam/queryHistoryExamResult?examId={0}',
    batchSubmitAnswer: '/user/exam/batchSubmitAnswer',
    getUserGroupList: '/manager/user/group/list4select',
    deleteUser: '/manager/deleteUserById?id={0}',
    deleteGroup: '/manager/user/group/deleteGroup?id={0}&keepUser={1}',
    getLogicalGroups: '/manager/logicalreasoning/list4select',
    getLogical2dGroups: '/manager/logicalreasoning/2d/list4select',
    getTextLogicalGroups: '/manager/logicalreasoning/text/list4select',
    getOpticalPathGroups: '/manager/optical-path/list4select',
    getUnfolding3DQuestionGroups: '/manager/unfolding3d/list4select',
    getLogicalQuestionTypeMap: '/manager/logicalreasoning/questionTypes',
    getLogicalQuestionByGroupId: '/manager/logicalreasoning/list?groupId={0}&page=0&pageSize=500',
    getLogical2dQuestionByGroupId: '/manager/logicalreasoning/2d/list?groupId={0}&page=0&pageSize=500',
    getTextLogicalQuestionByGroupId: '/manager/logicalreasoning/text/list?groupId={0}&page=0&pageSize=500',
    getTextLogicalQuestions: '/manager/logicalreasoning/text/list',
    getOpticalPathQuestions: '/manager/optical-path/list',
    deleteOpticalPathQuestion: '/manager/optical-path/delete?id={0}',
    deleteOpticalPathGroup: '/manager/optical-path/deleteGroup?groupId={0}',
    toggleOpticalPathQuestion: '/manager/optical-path/toggleEnabled',
    getTextAnalogyDetail: '/manager/logicalreasoning/text/analogy/detail',
    saveTextAnalogyDraft: '/manager/logicalreasoning/text/analogy/saveDraft',
    publishTextAnalogy: '/manager/logicalreasoning/text/analogy/publish',
    copyTextAnalogyAsDraft: '/manager/logicalreasoning/text/analogy/copyAsDraft',
    archiveTextAnalogy: '/manager/logicalreasoning/text/analogy/archive',
    getUnfolding3DQuestionByGroupId: '/manager/unfolding3d/list?groupId={0}&page=0&pageSize=500',
    deleteLogicalQuestion: '/manager/logicalreasoning/delete?id={0}',
    deleteLogical2dQuestion: '/manager/logicalreasoning/2d/delete?id={0}',
    deleteTextLogicalQuestion: '/manager/logicalreasoning/text/delete?id={0}',
    deleteUnfolding3dQuestion: '/manager/unfolding3d/delete?id={0}',
    deleteLogicalGroup: '/manager/logicalreasoning/deleteGroup?groupId={0}',
    deleteLogical2dGroup: '/manager/logicalreasoning/2d/deleteGroup?groupId={0}',
    deleteTextLogicalGroup: '/manager/logicalreasoning/text/deleteGroup?groupId={0}',
    deleteUnfolding3dGroup: '/manager/unfolding3d/deleteGroup?groupId={0}',
    getQuestionTplGroupList: '/manager/tpl/list4select',
    deleteTplGroup: '/manager/tpl/delete?groupId={0}',
    markTplGroupAsHistory: '/manager/tpl/markAsHistory?groupId={0}',
    getQuestionTplInfo: '/manager/tpl/question/info?tplId={0}',
    previewTplQuestion: '/manager/tpl/question/previewTplQuestion?tplId={0}',
    reGenerateQuestionTpl: '/manager/tpl/question/reGenerateQuestionTpl',
    updateTplQuestionId: '/manager/tpl/question/updateTplQuestionId',
    updateTplRuntimeParams: '/manager/tpl/question/updateRuntimeParams',
    getMechanicalArmPoseScenario: '/manager/tpl/question/mechanicalArmPose/scenario',
    saveMechanicalArmPoseScenario: '/manager/tpl/question/mechanicalArmPose/scenario',
    publishMechanicalArmPose: '/manager/tpl/question/mechanicalArmPose/publish',
    getTeachPlanInfo: '/manager/class/plan/info?planId={0}',
    addTpl2ClassPlan: '/manager/class/plan/addTpl',
    deleteTplFromPlan: '/manager/class/plan/deleteTpl',
    getClassRoomInfo: '/manager/class/room/info?roomId={0}',
    enableClassTpl: '/manager/class/room/enableClassTpl',
    queryClassRoom: '/user/class/room/queryClassRoom',
    getActiveTplList: '/user/class/room/getActiveTplList?roomId={0}',
    startTplWork: '/user/class/room/startTplWork',
    startTplWorkById: '/user/class/room/startTplWorkById?id={0}',
    getClassAnswerStatistic: '/manager/class/room/statistic',
    getSeesawGroups: '/manager/seesaw/list4select',
    getSeesawByGroupId: '/manager/seesaw/list?groupId={0}&page=0&pageSize=500',
    deleteSeesawQuestion: '/manager/seesaw/delete?id={0}',
    deleteSeesawGroup: '/manager/seesaw/deleteGroup?groupId={0}',
    getPriceCalculateGroups: '/manager/price/calculate/list4select',
    getPriceCalculateByGroupId: '/manager/price/calculate/list?groupId={0}&page=0&pageSize=500',
    deletePriceCalculateQuestion: '/manager/price/calculate/delete?id={0}',
    deletePriceCalculateGroup: '/manager/price/calculate/deleteGroup?groupId={0}',
    getUserMenu: '/user/info/menu',
    getDifficultySettings: '/manager/difficulty/setting/getSettings',
    updateSubjectSetting: '/manager/difficulty/setting/update',
    updateSystemSetting: '/manager/system/setting/update',
    updateRandomPractice: '/manager/tpl/question/updateRandomPractice?id={0}',
    getServerTime: '/open/serverTime',
    // 同一题型的统计数据啊
    getUserExamAverageAndRank: '/user/exam/getUserExamAverageAndRank',
    getUserExamstatistic: '/user/exam/getUserExamStatistic',
    // 获取班级套题做题数据
    getClassAnswerData: '/user/class/room/answerTable',
    // 管理段模拟考试
    // 计划
    getMockExamPlanList: '/manager/exam/mockExamPlanList',
    createMockExamPlan: '/manager/exam/addMockExamPlan',
    deleteMockExamPlan: '/manager/exam/deleteMockExamPlan',
    updateMockExamPlan: '/manager/exam/updateMockExamPlan',
    copyExamPlan: '/manager/exam/copyExamPlan',
    
    // 试卷
    createPaper: '/manager/paper/createPaper',
    getPaperList: '/manager/paper/paperList',
    getPaperDetail: '/manager/paper/paperDetail',
    deletePaper: '/manager/paper/deletePaper',
    updatePaper: '/manager/paper/updatePaper',
    
    // 单元
    addExamUnit: '/manager/paper/addUnit',
    // 用户端考试接口
    getUserExamList: '/user/mockExam/mockExamList',
    getmockExamDetail: '/user/mockExam/mockExamDetail',
    userStartMock: '/user/mockExam/startMock',
    getCurrentQuestion: '/user/mockExam/getCurrentQuestion',
    submitUnitAnswerV2: '/user/mockExam/submitUnitAnswerV2',
    batchSubmitUnitAnswerV2: '/user/mockExam/batchSubmitUnitAnswerV2',
    beginMockReaction: '/user/mockExam/reaction/begin',
    submitMockReactionAnswers: '/user/mockExam/reaction/answers',
    finishMockReaction: '/user/mockExam/reaction/finish',
    getMockExamResult: '/user/mockExam/getMockExamResult',
    getExamRank: '/user/mockExam/ranking?page=0&pageSize=50',
    // 立体纽结理论
    getKnotGroups: '/manager/knot/groupList',
    deleteKnotGroup: '/manager/knot/deleteGroup?groupId={0}',
    deleteKnotQuestion: '/manager/knot/delete?id={0}',
    getKnotQuestionByGroupId: '/manager/knot/list?groupId={0}&page=0&pageSize=500',

// - `POST /manager/knot/add` - 添加题目
// - `POST /manager/knot/addGroup` - 添加分组
// - `POST /manager/knot/zipUpload` - 上传zip包



    queryForm: {
        1: '/manager/class/plan/getQueryForm'
    },
    dialogs: {
        1: '/manager/practice/chance/getPracticeEditForm?userId={0}',
        2: '/manager/user/group/getUserGroupEditDialog?userId={0}',
        3: '/manager/getUserCreateForm?groupId={0}',
        4: '/manager/getUserCreateForm',
        5: '/manager/user/group/getCreateGroupDialog',
        6: '/manager/logicalreasoning/getCreateGroupDialog',
        7: '/manager/logicalreasoning/getUploadDialog',
        8: '/manager/tpl/getCreateGroupDialog',
        9: '/manager/tpl/question/getCreateDialog',
        10: '/manager/tpl/question/getEditDialog?id={0}',
        11: '/manager/class/plan/getCreateDialog',
        12: '/manager/class/plan/getEditDialog?id={0}',
        13: '/manager/class/room/getCreateDialog',
        14: '/manager/class/room/getOffClassDialog',
        15: '/manager/seesaw/getCreateGroupDialog',
        16: '/manager/seesaw/getUploadDialog',
        17: '/manager/getUserUploadForm?groupId={0}',
        18: '/manager/getUserExamReviewForm?userId={0}',
        19: '/manager/price/calculate/getCreateGroupDialog',
        20: '/manager/price/calculate/getUploadDialog',
        21: '/manager/unfolding3d/getCreateGroupDialog',
        22: '/manager/unfolding3d/getUploadDialog',
        23: '/manager/logicalreasoning/2d/getCreateGroupDialog',
        27: '/manager/logicalreasoning/text/getCreateGroupDialog',
        28: '/manager/logicalreasoning/text/getUploadDialog',
        29: '/manager/logicalreasoning/getSingleUploadDialog',
        30: '/manager/logicalreasoning/2d/getUploadDialog',
        31: '/manager/logicalreasoning/2d/getSingleUploadDialog',
        32: '/manager/logicalreasoning/text/getSingleUploadDialog',
        33: '/manager/unfolding3d/getSingleUploadDialog',
        34: '/manager/knot/getSingleUploadDialog',
        35: '/manager/optical-path/getCreateGroupDialog',
        36: '/manager/optical-path/getCreateQuestionDialog',
        37: '/manager/optical-path/getEditQuestionDialog?id={0}',
        // 设置账户到期时间和类别（刷机上课）
        24: '/manager/getUserAccountUsageExpire?userId={0}',
        // 新题型 knot
        25: '/manager/knot/getCreateGroupDialog',
        26: '/manager/knot/getUploadDialog',
    },
    simpleBtn: {
        1: {
            dialogId: 1,
            submitUrl: '/manager/practice/chance/updatePracticeChance',
        },
        2: {
            dialogId: 2,
            submitUrl: '/manager/user/group/updateUserGroupConfig',
        },
        3: {
            dialogId: 3,
            submitUrl: '/manager/createUser',
        },
        4: {
            dialogId: 5,
            submitUrl: '/manager/user/group/createGroup',
        },
        5: {
            dialogId: 6,
            submitUrl: '/manager/logicalreasoning/addGroup',
        },
        6: {
            dialogId: 7,
            submitUrl: '/manager/logicalreasoning/zipUpload',
        },
        7: {
            dialogId: 8,
            submitUrl: '/manager/tpl/createGroup',
        },
        8: {
            dialogId: 9,
            submitUrl: '/manager/tpl/question/create',
        },
        9: {
            dialogId: 13,
            submitUrl: '/manager/class/room/create',
        },
        10: {
            dialogId: 14,
            submitUrl: '/manager/class/room/offClass',
        },
        11: {
            dialogId: 15,
            submitUrl: '/manager/seesaw/addGroup',
        },
        12: {
            dialogId: 16,
            submitUrl: '/manager/seesaw/importFromXlsx',
        },
        13: {
            dialogId: 17,
            submitUrl: '/manager/importUserFromXlsx',
        },
        14: {
            dialogId: 18,
            submitUrl: '/manager/updateUserExamReviewForm',
        },
        15: {
            dialogId: 19,
            submitUrl: '/manager/price/calculate/addGroup',
        },
        16: {
            dialogId: 20,
            submitUrl: '/manager/price/calculate/importFromXlsx',
        },
        17: {
            dialogId: 21,
            submitUrl: '/manager/unfolding3d/addGroup',
        },
        18: {
            dialogId: 22,
            submitUrl: '/manager/unfolding3d/zipUpload',
        },
        19: {
            dialogId: 23,
            submitUrl: '/manager/logicalreasoning/2d/addGroup',
        },
        27: {
            dialogId: 27,
            submitUrl: '/manager/logicalreasoning/text/addGroup',
        },
        28: {
            dialogId: 28,
            submitUrl: '/manager/logicalreasoning/text/zipUpload',
        },
        29: {
            dialogId: 29,
            submitUrl: '/manager/logicalreasoning/singleUpload',
        },
        30: {
            dialogId: 30,
            submitUrl: '/manager/logicalreasoning/2d/zipUpload',
        },
        31: {
            dialogId: 31,
            submitUrl: '/manager/logicalreasoning/2d/singleUpload',
        },
        32: {
            dialogId: 32,
            submitUrl: '/manager/logicalreasoning/text/singleUpload',
        },
        33: {
            dialogId: 33,
            submitUrl: '/manager/unfolding3d/singleUpload',
        },
        34: {
            dialogId: 34,
            submitUrl: '/manager/knot/singleUpload',
        },
        35: {
            dialogId: 35,
            submitUrl: '/manager/optical-path/addGroup',
        },
        36: {
            dialogId: 36,
            submitUrl: '/manager/optical-path/save',
        },
        37: {
            dialogId: 37,
            submitUrl: '/manager/optical-path/save',
        },
        20: {
            dialogId: 24,
            submitUrl: '/manager/updateUserAccountUsageExpire',
        },
        // 新题型
        21: {
            dialogId: 25,
            submitUrl: '/manager/knot/addGroup',
        },
        22: {
            dialogId: 26,
            submitUrl: '/manager/knot/zipUpload',
        },
    },
    table: {
        1: {
            list: '/manager/user/group/userList',
        },
        2: {
            list: '/manager/tpl/question/list',
            updateDialog: 10,
            updateKey: 'id',
            update: '/manager/tpl/question/update',
            delete: '/manager/tpl/question/delete',
            deleteKey: 'id',
        },
        3: {
            queryForm: 1,
            list: '/manager/class/plan/list',
            createDialog: 11,
            create: '/manager/class/plan/create',
            updateDialog: 12,
            updateKey: 'id',
            update: '/manager/class/plan/update',
            delete: '/manager/class/plan/delete',
            deleteKey: 'id',
        },
        4: {
            list: '/manager/class/room/list',
            delete: '/manager/class/room/delete',
            deleteKey: 'id',
        },
        5: {
            list: '/manager/class/room/userLoginTable',
        },
        6: {
            list: '/user/class/room/homework',
        },
        7: {
            list: '/user/answer/history/list',
        },
        8: {
            list: '/manager/class/room/answerTable',
        },
        9: {
            list: '/user/class/room/classwork',
        },
    }

}

export default base;
